import { FunctionComponent } from 'react'
import { Icon } from '~/components/Icon'
import { Tooltip } from '~/components/Tooltip'
import { useAdFormat } from './AdFormatDisplay'

/**
 * The ad unit's format, drawn beside its name.
 *
 * Neither ad units list carried the format at all — it lived only inside the View flyout, so telling a
 * leaderboard from an interstitial meant opening every row in turn. The glyph is the one the format
 * picker already uses, so the shape learned when the ad unit was created is the shape that identifies it
 * afterwards; the name rides in a tooltip rather than a second column, which would cost a third of the
 * table's width to repeat what the picture says.
 *
 * Renders nothing for an ad unit with no format, rather than a placeholder: the four Node envs each
 * allow a different set, and an ad unit created before formats existed has none.
 */
export const AdFormatIcon: FunctionComponent<{ adFormatId?: string }> = ({ adFormatId }) => {
  const adFormat = useAdFormat(adFormatId)

  if (!adFormat) {
    return null
  }

  return (
    <Tooltip title={adFormat.name}>
      <Icon name={adFormat.iconName} width={'32px'} />
    </Tooltip>
  )
}
